module.exports = __webpack_public_path__ + "static/media/secure.893be855.svg";